import React from "react";
import {
  Phone,
  Mail,
  Clock,
  MapPin,
  Send,
  MessageSquare,
  HelpCircle,
  FileText,
  BookOpen
} from "lucide-react";
import { Link } from "react-router-dom";
import Navigation from "../components/Navigation";
import FooterSection from "../components/FooterSection";
import "./ContactUs.css";

const ContactUs = () => {
  return (
    <div className="contact-container">
      {/* Header Section */}
      <header className="contact-header">
        <div className="header-badge">
          <Mail size={14} />
          <span>Get In Touch</span>
        </div>
        <h1 className="contact-title">Contact <span className="gradient-text">Our Team</span></h1>
        <p className="contact-subtitle">Have questions? We're here to help you 24/7</p>
      </header>

      <main className="contact-main">
        {/* Top Info Cards */}
        <section className="info-cards">
          <div className="info-card">
            <div className="info-icon blue">
              <Phone size={24} />
            </div>
            <h3>Phone Support</h3>
            <p>Speak with our healthcare technology experts</p>
            <span className="info-detail">+1 (555) 123-4567</span>
            <span className="info-sub-detail">Emergency: +1 (555) 999-0000</span>
          </div>

          <div className="info-card">
            <div className="info-icon green">
              <Mail size={24} />
            </div>
            <h3>Email Us</h3>
            <p>Send us an email and we'll respond within 24 hours</p>
            <span className="info-detail">support@healthmonitor.io</span>
            <span className="info-sub-detail">sales@healthmonitor.io</span>
          </div>

          <div className="info-card">
            <div className="info-icon orange">
              <Clock size={24} />
            </div>
            <h3>Business Hours</h3>
            <p>Our support team is available around the clock</p>
            <span className="info-detail">24/7 Support</span>
            <span className="info-sub-detail">365 days a year</span>
          </div>
        </section>

        {/* Main Form & Sidebar */}
        <section className="contact-grid">
          {/* Form Side */}
          <div className="form-section">
            <div className="md-section-title">
              <h2>Send us a Message</h2>
              <p>Fill out the form below and our team will get back to you shortly</p>
            </div>

            <form className="contact-form" onSubmit={(e) => e.preventDefault()}>
              <div className="form-row">
                <div className="input-group">
                  <label>First Name</label>
                  <input type="text" placeholder="John" />
                </div>
                <div className="input-group">
                  <label>Last Name</label>
                  <input type="text" placeholder="Doe" />
                </div>
              </div>

              <div className="input-group">
                <label>Email</label>
                <input type="email" placeholder="john.doe@example.com" />
              </div>

              <div className="input-group">
                <label>Phone Number</label>
                <input type="tel" placeholder="+1 (555) 123-4567" />
              </div>

              <div className="input-group">
                <label>Subject</label>
                <input type="text" placeholder="How can we help?" />
              </div>

              <div className="input-group">
                <label>Message</label>
                <textarea placeholder="Tell us more about your inquiry..." rows={5}></textarea>
              </div>

              <button type="submit" className="submit-btn">
                <Send size={18} />
                <span>Send Message</span>
              </button>
            </form>
          </div>

          {/* Sidebar Area */}
          <div className="sidebar-section">
            {/* Office Location */}
            <div className="sidebar-card office-card">
              <div className="card-header">
                <MapPin size={20} className="icon-blue" />
                <h3>Our Office</h3>
              </div>
              <div className="office-details">
                <p className="office-name">Headquarters</p>
                <p>123 Healthcare Innovation Drive</p>
                <p>Medical Technology Park</p>
                <p>San Francisco, CA 94158</p>
                <p>United States</p>
              </div>
              <div className="map-placeholder">
                <div className="map-inner">
                  <MapPin size={32} className="map-marker" />
                </div>
              </div>
            </div>

            {/* Quick Help Links */}
            <div className="sidebar-card help-card">
              <div className="card-header">
                <HelpCircle size={20} className="icon-cyan" />
                <h3>Quick Help</h3>
              </div>
              <p className="help-text">Find answers to common questions</p>
              <div className="help-links">
                <Link to="/help" className="help-link">
                  <MessageSquare size={16} />
                  <span>Visit Help Center</span>
                </Link>
                <Link to="/documentation" className="help-link">
                  <BookOpen size={16} />
                  <span>View Documentation</span>
                </Link>
                <Link to="/privacy" className="help-link">
                  <FileText size={16} />
                  <span>Privacy Policy</span>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  );
};

export default ContactUs;
